import { TokenTypes } from '..';
import { BaseService, RequestMethod } from './BaseService';

export namespace CartService {
  export interface ISetCartItemsV1Request {
    productId: string;
    currency: string;
  }

  export interface ISetCartItemsByProductCodeRequest {
    readonly productCode: string;
    readonly currency: string;
    readonly dataset: string;
  }

  export interface ISetCartItemsByProductIdRequest {
    readonly productId: string;
    readonly currency: string;
    readonly dataset: string;
  }

  export interface ISetCartItemsResponse {
    cartId: string;
    cartItemId: string;
    productId: string;
    quantity: number;
  }

  export interface IAddToCartMultipleProductsItem {
    readonly productId: string;
    readonly quantity: number;
  }

  export interface IAddToCartMultipleProductsRequest {
    readonly products: IAddToCartMultipleProductsItem[];
    readonly currency: string;
  }

  export interface IAddToCartMultipleProductsResponseItem {
    readonly cartItemId: string;
    readonly productId: string;
    readonly quantity: string;
    readonly name: string;
  }

  export interface IAddToCartMultipleProductsResponse {
    readonly cartId: string;
    readonly cartItems: IAddToCartMultipleProductsResponseItem[];
  }

  export class Api extends BaseService {

    constructor() {
      super({ configPath: 'services.cart' });
    }

    /**
     *
     * @returns
     */
    async add(request: ISetCartItemsV1Request): Promise<ISetCartItemsResponse> {
      const data = <unknown>request as Record<string, unknown>;
      return this.requestResource('cartItems', {
        method: RequestMethod.POST,
        tokenType: TokenTypes.ID,
        data,
      });
    }

    async addMultiple(request: IAddToCartMultipleProductsRequest): Promise<IAddToCartMultipleProductsResponse> {
      const data = <unknown>request as Record<string, unknown>;
      return this.requestResource('cart', {
        method: RequestMethod.POST,
        tokenType: TokenTypes.ID,
        data,
      });
    }

    /**
     *
     * @returns
     */
    async addByProductId(request: ISetCartItemsByProductIdRequest): Promise<ISetCartItemsResponse> {
      return this.requestResource('cartItems', {
        method: RequestMethod.POST,
        tokenType: TokenTypes.ID,
        data: {
          ...request,
          use: 'productId',
        },
        headers: {
          'x-api-version': '2',
        },
      });
    }

    async addByProductCode(request: ISetCartItemsByProductCodeRequest): Promise<ISetCartItemsResponse> {
      return this.requestResource('cartItems', {
        method: RequestMethod.POST,
        tokenType: TokenTypes.ID,
        data: {
          ...request,
          use: 'productCode',
        },
        headers: {
          'x-api-version': '2',
        },
      });
    }

    async sfConfig() {
      const config = await this.core.api.config.freshConfig();
      return config.configRoot.salesforce;
    }

    async sfCartUrl(cartId: string) {
      const { appUrl } = await this.sfConfig();
      return `${appUrl}/cart/${cartId}`;
    }

    async sfRedirect() {
      const { appUrl } = await this.sfConfig();
      return `${appUrl}/redirect`;
    }
  }
}

export default CartService.Api;
